(() => {
  const dialog = document.getElementById('QuickLook');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  const image = dialog.querySelector('.quick-look__image');
  const title = dialog.querySelector('.quick-look__title');
  const variant = dialog.querySelector('.quick-look__variant');
  // On the cart page the image container sits on top of the product link, so both are triggers.
  const triggers =
    '[data-quick-look], .cart-item__media .cart-item__link, .cart-item__media .cart-item__image-container';

  function largeImageUrl(src) {
    const url = new URL(src, window.location.href);
    url.searchParams.set('width', '1500');
    return url.href;
  }

  function getContent(trigger) {
    if (trigger.hasAttribute('data-quick-look')) {
      return {
        src: trigger.dataset.quickLookSrc,
        title: trigger.dataset.quickLookTitle,
        options: (trigger.dataset.quickLookVariant || '').split(' / '),
      };
    }

    // Cart page: read the item from its table row.
    const row = trigger.closest('.cart-item');
    const rowImage = row && row.querySelector('.cart-item__image');
    if (!rowImage) return null;
    const name = row.querySelector('.cart-item__name');
    return {
      src: largeImageUrl(rowImage.currentSrc || rowImage.src),
      title: name ? name.textContent.trim() : rowImage.alt,
      options: Array.from(row.querySelectorAll('dl .product-option dd')).map((option) => option.textContent),
    };
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(triggers);
    if (!trigger || event.metaKey || event.ctrlKey || event.shiftKey) return;
    const content = getContent(trigger);
    if (!content || !content.src) return;

    event.preventDefault();
    // '-' is the placeholder value of options that do not apply to the variant.
    const options = content.options
      .map((option) => option.trim())
      .filter((option) => option && option !== '-')
      .join(' / ');
    image.removeAttribute('src');
    image.src = content.src;
    image.alt = content.title || '';
    title.textContent = content.title || '';
    variant.textContent = options;
    variant.hidden = !options;
    dialog.showModal();
  });

  dialog.addEventListener('click', (event) => {
    // The cart notification closes on any click that reaches the body.
    event.stopPropagation();
    if (event.target === dialog || event.target.closest('.quick-look__close')) dialog.close();
  });

  // Close on keyup instead of keydown, otherwise the same Escape keyup also closes the cart notification.
  dialog.addEventListener('cancel', (event) => event.preventDefault());
  dialog.addEventListener('keyup', (event) => {
    if (event.code === 'Escape') dialog.close();
  });
})();
